<template>
  <div style="display: flex; flex-direction: column; align-items: center">
    <div class="table-wrapper">
      <el-table
        border
        v-loading="selectLoading || requestLoading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        :data="tableData"
        :header-cell-style="{ background: '#efefef', textAlign: 'center', color: '#333' }"
        :cell-style="{ textAlign: 'center' }"
      >
        <el-table-column type="index" label="序号" width="80"> </el-table-column>
        <el-table-column label="工号" width="180">
          <template slot-scope="scope">
            <el-select
              v-model="scope.row.jobNumber"
              filterable
              clearable
              @change="jobNumberChange($event, scope.$index)"
              placeholder="请选择"
              size="small"
            >
              <el-option v-for="item in jobNumbers" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="名称" width="160">
          <template slot-scope="{ row }">
            <el-input v-model="row.name" :disabled="true" size="small" placeholder="请选择工号"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="公务卡号" width="240">
          <template slot-scope="{ row }">
            <el-input v-model="row.cardNumber" :disabled="true" size="small" placeholder="请选择工号"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="消费日期" width="200">
          <template slot-scope="{ row }">
            <el-date-picker v-model="row.date" type="date" placeholder="选择日期" size="small" style="width: 100%">
            </el-date-picker>
          </template>
        </el-table-column>
        <el-table-column label="商户名称" width="240">
          <template slot-scope="{ row }">
            <el-input v-model="row.merchantName" clearable size="small"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="消费金额" width="160">
          <template slot-scope="{ row }">
            <el-input v-model="row.consumptionAmount" type="number" size="small"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="报销金额" width="160">
          <template slot-scope="{ row }">
            <el-input v-model="row.reimbursementAmount" type="number" size="small"></el-input>
          </template>
        </el-table-column>
        <el-table-column label="消费用途" width="180">
          <template slot-scope="{ row }">
            <el-select v-model="row.consumptionUse" filterable placeholder="请选择" size="small">
              <el-option v-for="item in consumptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="删除" width="120">
          <template slot-scope="scope">
            <div class="delete-icon-wrapper" @click="deleteData(scope.$index)">
              <div class="delete-icon"><i class="el-icon-delete-solid"></i></div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 操作按钮 -->
    <div class="button-wrapper">
      <el-button type="primary" :disabled="selectLoading || requestLoading" @click="resetData">重 置</el-button>
      <el-button type="primary" :disabled="selectLoading || requestLoading" @click="addData">新增一行</el-button>
      <el-button type="primary" :disabled="selectLoading" :loading="requestLoading" @click="inquireData"
        >查 询</el-button
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'EnquiryForm',
  data() {
    return {
      selectLoading: false,
      requestLoading: false,
      tableData: [
        {
          jobNumber: '', // 工号
          name: '', // 名称
          cardNumber: '', // 公务卡号
          date: '', // 消费日期
          merchantName: '', // 商户名称
          consumptionAmount: '', // 消费金额
          reimbursementAmount: '', // 报销金额
          consumptionUse: '', // 消费用途
        },
      ],
      // ------------测试数据--------------
      // 工号
      jobNumbers: [
        { value: '1001', label: '1001' },
        { value: '1002', label: '1002' },
        { value: '1003', label: '1003' },
        { value: '1004', label: '1004' },
        { value: '1005', label: '1005' },
      ],
      // 工号对应表
      jobNumbersTable: [
        { number: '1001', name: '名字1001', cardNumber: '公务卡号1001' },
        { number: '1002', name: '名字1002', cardNumber: '公务卡号1002' },
        { number: '1003', name: '名字1003', cardNumber: '公务卡号1003' },
        { number: '1004', name: '名字1004', cardNumber: '公务卡号1004' },
        { number: '1005', name: '名字1005', cardNumber: '公务卡号1005' },
      ],
      // 消费用途
      consumptions: [
        { value: '1', label: '消费用途1' },
        { value: '2', label: '消费用途2' },
        { value: '3', label: '消费用途3' },
        { value: '4', label: '消费用途4' },
        { value: '5', label: '消费用途5' },
      ],
      // ------------测试数据--------------
    };
  },
  created() {
    // 获取路径参数
    const urlParams = new URLSearchParams(window.location.search);
    const id = urlParams.get('id') || '0';
    console.log('请求数据 id:', id);
  },
  methods: {
    // 工号选择
    jobNumberChange(value, index) {
      const tableData = this.copyData(this.tableData);
      if (value === '') {
        // 清空操作
        tableData[index].jobNumber = '';
        tableData[index].name = '';
        tableData[index].cardNumber = '';
      } else {
        // 设置工号
        tableData[index].jobNumber = value;
        // 设置名称
        const dataIndex = this.jobNumbersTable.findIndex((item) => item.number === value);
        tableData[index].name = this.jobNumbersTable[dataIndex].name;
        // 设置公务卡号
        tableData[index].cardNumber = this.jobNumbersTable[dataIndex].cardNumber;
      }
      this.tableData = tableData;

      // ------------测试，模拟 loading --------------
      this.selectLoading = true;
      setTimeout(() => {
        this.selectLoading = false;
      }, 1500);
      // ------------测试，模拟 loading --------------
    },

    // 重置
    resetData() {
      this.tableData = [
        {
          jobNumber: '', // 工号
          name: '', // 名称
          cardNumber: '', // 公务卡号
          date: '', // 消费日期
          merchantName: '', // 商户名称
          consumptionAmount: '', // 消费金额
          reimbursementAmount: '', // 报销金额
          consumptionUse: '', // 消费用途
        },
      ];
    },

    // 新增一行
    addData() {
      const newRowData = {
        jobNumber: '', // 工号
        name: '', // 名称
        cardNumber: '', // 公务卡号
        date: '', // 消费日期
        merchantName: '', // 商户名称
        consumptionAmount: '', // 消费金额
        reimbursementAmount: '', // 报销金额
        consumptionUse: '', // 消费用途
      };
      const copyData = this.copyData(this.tableData);
      this.tableData = copyData.concat(newRowData);
    },

    // 删除一行
    deleteData(index) {
      const copyData = this.copyData(this.tableData);
      copyData.splice(index, 1);
      this.tableData = copyData;
    },

    // 查询
    inquireData() {
      // ------------测试，模拟 loading --------------
      this.requestLoading = true;
      setTimeout(() => {
        this.requestLoading = false;
      }, 1500);
      // ------------测试，模拟 loading --------------

      this.$message({
        message: '功能待完善',
        type: 'warning',
      });
      console.log('this.tableData', this.tableData);
      // this.$http
      //   .get('')
      //   .then((response) => {
      //     console.log('请求数据:', response);
      //   })
      //   .catch((error) => {
      //     console.error('请求失败:', error);
      //   });
      // this.$http
      //   .post('', {})
      //   .then((response) => {
      //     console.log('请求数据:', response);
      //   })
      //   .catch((error) => {
      //     console.error('请求失败:', error);
      //   });
    },

    // JSON 复制数据
    copyData(data) {
      return JSON.parse(JSON.stringify(data));
    },
  },
};
</script>

<style scoped>
.table-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1721px;
  min-width: 1200px;
  margin: 100px auto 20px;
}

.delete-icon-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 16px;
  font-size: 20px;
  color: red;
}

.delete-icon {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  text-align: center;
  cursor: pointer;
}

.delete-icon:active {
  transform: scale(0.98);
  color: lightcoral;
}

.button-wrapper {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 1721px;
}

/* 重置组件按钮样式 */
.el-button--primary {
  border-radius: 16px;
  color: #fff;
  background-color: #004787;
  border-color: #004787;
}

.el-button--primary:active {
  transform: scale(0.98);
  background-color: #4e789c;
  border-color: #4e789c;
}
</style>
